import React, { useEffect, useState } from 'react'
import config from '../coreFIles/config';
import toast, { Toaster } from 'react-hot-toast';
import Header from '../directives/header'
import Footer from '../directives/footer'
import Sidebar from '../directives/sidebar'
import { CreateUserAction, getSearchSuburbAction, getMonthlySpendlistAction, getTieredGrouplistAction, getindustrylistAction, getActiveOwnersListAction } from '../Action/action';
import Cookies from "js-cookie";
const loginData = (!Cookies.get('loginSuccessfastenerwarehouseAdmin')) ? [] : JSON.parse(Cookies.get('loginSuccessfastenerwarehouseAdmin'));

const CreateUser = () => {	
	 
	const [form, setForm] = useState({ first_name: '', last_name: '', email: '', accounts_email_address: '', other_email_addresss: '', send_emails_to_both_emails: '0', password: '', phone: '', company: '', industry: '', address: '', suburb: '', state: '', postcode: '', abn: '', monthly_spend: '', is_cod: '1', product_range: 0, minimum_order_total: '', free_shipping: '', minimum_amout_for_free_shipping: '', override_global_free_shipping:0, tiered_group: '', is_active: '1', country: 'AU', force_user_to_change_pwd:'1',owner_id:0  });
	const [validationError, setvalidationError] = useState({});
	const [formErrors, setFormErrors] = useState([]); // live fix 21 Oct: messages listed at the top of the form
	const [saveError, setSaveError] = useState('');
	const [saving, setSaving] = useState(false);
	const [SuburbsearchResults, setSuburbsearchResults] 	= useState([]);
	const [industry, setindustry] 	= useState([]);
	const [owners, setowners] 					= useState([]);
	const [tiered_group, settiered_group] 	= useState([]);
	const [monthly_spend, setmonthly_spend] 	= useState([]);
	const [suburb, setsuburb] 	= useState('');
	const [postcode, setpostcode] 	= useState('');
	const [showcod, setshowcod] 	= useState(0);
	useEffect(()=>{
		getindustryAPI();
		gettiered_groupAPI();
		getmonthly_spendAPI();	
		getOwnersAPI();				
    },[]);
    
    const getOwnersAPI = async () => {
		let res = await getActiveOwnersListAction();
		if (res.success) {
			let data = res.data;			
			setowners(data);	
		}else{
			setowners([]);	
		}
	}
    
    const getindustryAPI = async () => {
		let res = await getindustrylistAction();
		if (res.success) {
			let data = res.data;			
			setindustry(data);	
		}
		else
		{
			setindustry([]);	
		}
	}
    const gettiered_groupAPI = async () => {
		let res = await getTieredGrouplistAction();
		if (res.success) {
			let data = res.data;			
			settiered_group(data);	
		}
		else
		{
			settiered_group([]);	
		}
	}
    const getmonthly_spendAPI = async () => {
		let res = await getMonthlySpendlistAction();
		if (res.success) {
			let data = res.data;			
			setmonthly_spend(data);	
		}
		else
		{
			setmonthly_spend([]);	
		}
	}
	
	const inputHandler = async (e) => {
		const { name, value } = e.target
		const next = name === "abn" ? String(value || "").replace(/\D/g, "").slice(0, 11) : value
		setForm((old) => {
			return { ...old, [name]: next }
		})
	}
	const inputmonthly_spendHandler = async (e) => {
		const { name, value } = e.target
		setForm((old) => {
			return { ...old, [name]: value }
		})
		if(value==1){
			setForm((old) => {
			return { ...old, 'is_cod': 1 }
		})
		}else if(value > 1){
			setForm((old) => {
			return { ...old, 'is_cod': 2 }
		})
		}else{
			setForm((old) => {
				return { ...old, 'is_cod': 1 }
			})
		}
	}
	const handleinvoiceCheckboxChange = (e) => {
		if(e.target.checked==true){
		 setForm((old) => {
			return { ...old, 'send_emails_to_both_emails': 1 };
		});	 
		}else{
			setForm((old) => {
			return { ...old, 'send_emails_to_both_emails': 0 };
		});	 
		}
	  };
	const handleKeyPress = (e) => {
		// Allow only numeric values (0-9) and certain control keys
		const isValidInput = /^[0-9\b]+$/.test(e.key);

		if (!isValidInput) {
		  e.preventDefault();
		}
	  }; 
	const SearchSuburb = async (str) => {
		try {
			setsuburb(str);
			setpostcode('');
			setForm((old) => {
				return { ...old, 'suburb': '' };
			});
			setForm((old) => {
				return { ...old, 'postcode': '' };
			});
			setForm((old) => {
				return { ...old, 'state': '' };
			});
			let res = await getSearchSuburbAction({str:str});
			setSuburbsearchResults(res.data);
		}
		catch (error) {
			console.error(error);
		}
	};	   
    const handleSelectSuburb = (row) => {
	   console.log(row)
		setsuburb(row.suburb);
		setpostcode(row.postcode);
		setForm((old) => {
			return { ...old, 'suburb': row.suburb };
		});
		setForm((old) => {
			return { ...old, 'postcode': row.postcode };
		});
		setForm((old) => {
			return { ...old, 'state': row.state };
		});
		setSuburbsearchResults({});
	};	
	
   function validate() {	   
		let first_nameError = "";
		let last_nameError = "";
		let emailError = "";
		let passwordError = "";
		let phoneError = "";
		let companyError = "";
		let industryError = "";
		let addressError = "";
		let suburbError = "";
		let stateError = "";
		let postcodeError = "";
		let abnError = "";
		let monthly_spendError = "";
		let is_codError = "";
		let minimum_order_totalError = "";
		let free_shippingError = "";
		let minimum_amout_for_free_shippingError = "";
		let tiered_groupError = "";		
		let is_activeError = "";
		
		if (form.first_name === '') {
		  first_nameError = "First name is required."
		}
		if (form.last_name === '') {
			last_nameError = "Last name is required."
		}
		if (form.email === '') {
			emailError = "Email is required."
		}
		if (form.password === '') {
			passwordError = "Password is required."
		}
		if (form.phone === '') {
			phoneError = "Phone is required."
		}
		if (form.company === '') {
			companyError = "Company name is required."
		}
		if (form.company != '' && form.company.length>30) {
			companyError = "Company title must not exceed 30 characters."
		}
		if (form.industry === '') {
			industryError = "Industry is required."
		}
		if (form.address === '') {
			addressError = "Address is required."
		}
		if (form.suburb === '') {
			suburbError = "Suburb is required."
		}
		if (form.state === '') {
			stateError = "State is required."
		}
		if (form.postcode === '') {
			postcodeError = "Postcode is required."
		}
		if (form.abn === '') {
			abnError = "ABN is required."
		}
		
		if (form.abn != '' && form.abn.length!=11) {
			abnError = "Please enter a valid 11 digit ABN"
		}
		
		
		if (form.monthly_spend === '') {
			monthly_spendError = "Monthly spend is required."
		}
		if (showcod==1 && form.is_cod === '') {
			is_codError = "COD or a 30 day is required."
		}
		if (form.minimum_order_total === '') {
			minimum_order_totalError = "Minimum order total is required."
		}
		if (form.tiered_group === '') {
			tiered_groupError = "Tiered group is required."
		}
		if (form.is_active === '') {
			is_activeError = "Status is required."
		}
		
		if(form.email != '')
		{
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if(emailRegex.test(form.email) === false)
			{
				emailError = "Please enter valid email."
			}
		}
		
		
				
		// Live fix 21 Oct: list every problem at the top of the form and scroll to the first field to fix.
		const errorList = [
			['first_name', first_nameError], ['last_name', last_nameError], ['email', emailError], ['password', passwordError],
			['phone', phoneError], ['company', companyError], ['industry', industryError], ['abn', abnError],
			['address', addressError], ['suburb', suburbError], ['postcode', postcodeError], ['state', stateError],
			['minimum_order_total', minimum_order_totalError], ['monthly_spend', monthly_spendError], ['is_cod', is_codError],
			['free_shipping', free_shippingError], ['minimum_amout_for_free_shipping', minimum_amout_for_free_shippingError],
			['tiered_group', tiered_groupError], ['is_active', is_activeError],
		].filter((row) => row[1]);
		setFormErrors(errorList.map((row) => row[1]));
		if (errorList.length) {
			setTimeout(() => {
				const summary = document.getElementById('createuser-errors');
				if (summary) summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
				const first = document.getElementById(errorList[0][0]);
				if (first && !first.disabled) first.focus({ preventScroll: true });
			}, 0);
		}

		if (first_nameError || last_nameError || emailError || passwordError || phoneError || companyError || industryError || addressError|| suburbError|| stateError|| postcodeError|| abnError|| monthly_spendError|| is_codError|| minimum_order_totalError|| free_shippingError|| minimum_amout_for_free_shippingError|| tiered_groupError|| is_activeError) {
			setvalidationError({
			  first_nameError, last_nameError, emailError, passwordError, phoneError, companyError, industryError, addressError, suburbError, stateError, postcodeError, abnError, monthly_spendError, is_codError, minimum_order_totalError, free_shippingError, minimum_amout_for_free_shippingError, tiered_groupError, is_activeError
			})
			return false
		} else {
			setvalidationError({
			  first_nameError, last_nameError, emailError, passwordError, phoneError, companyError, industryError, addressError, suburbError, stateError, postcodeError, abnError, monthly_spendError, is_codError, minimum_order_totalError, free_shippingError, minimum_amout_for_free_shippingError, tiered_groupError, is_activeError
			})
			return true
		}
	}
	
	const SubmitForm = async (e) => {
		e.preventDefault()
		if (saving) return;
		setSaveError('');
		const isValid = validate();
		if (!isValid) {
			return;
		}
		setSaving(true);
		try {
			let res = await CreateUserAction(form);
			if (res && res.success) {
				toast.success(res.msg);
				setTimeout(() => {
					window.location.href = `${config.baseUrl}users`;
				}, 1200);
				return; // keep the button disabled while the page moves on
			}
			const msg = (res && res.msg) || "Couldn't save the account. Please try again.";
			setSaveError(msg);
			toast.error(msg);
		} catch (err) {
			// Expired logins are sent to the login page by coreFIles/helper.js; anything else is shown here.
			setSaveError("Couldn't reach the server. Please try again.");
		}
		setSaving(false);
	}
 

  return (

    <>
      <Sidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <Toaster />
        <Header />
         <div className="container-lg mb-4">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb my-0 ms-2">
              <li className="breadcrumb-item">
               <span><a className="homelink" href={`${config.baseUrl}users`} >Home</a></span>
              </li>
              <li className="breadcrumb-item active"><span>Create User</span></li>
            </ol>
          </nav>
        </div>
        <div className="body flex-grow-1 px-3">
        <div className="container-lg">
          <div className="row">
            
          <div className="col-md-12">
              <div className="card mb-4">
                <div className="card-header">
					<div className="row align-items-center">				
						<div className="col-md-6 text-start">
						 <span>Create User</span>
						</div>
						<div className="col-md-6 text-end">
							<a className="btn btn-primary editbtn" href={`${config.baseUrl}users`} >Back</a>
						</div>
					</div>
                </div>
                <div className="card-body inner-body">                
                 {formErrors.length ? (
					<div id="createuser-errors" className="alert alert-danger" role="alert">
						<strong>Please fix {formErrors.length === 1 ? 'the field' : `the ${formErrors.length} fields`} marked in red:</strong>
						<ul className="mb-0">{formErrors.map((msg, i) => <li key={i}>{msg}</li>)}</ul>
					</div>
				 ) : null}
                 <form className="row g-3">
					 <div className="col-md-6">
						<label className="form-label" for="first_name">First name<span className="req-star">*</span></label>
						<input className={validationError.first_nameError ? 'form-control is-invalid' : 'form-control'} id="first_name" name="first_name" placeholder="Enter first name" type="text" onChange={inputHandler} />
						<div className="invalid-feedback">{validationError.first_nameError}</div>
					  </div>
					  <div className="col-md-6">
						<label className="form-label" for="last_name">Last name<span className="req-star">*</span></label>
						<input className={validationError.last_nameError ? 'form-control is-invalid' : 'form-control'} id="last_name" name="last_name" placeholder="Enter last name" type="text" onChange={inputHandler} />
						<div className="invalid-feedback">{validationError.last_nameError}</div>
					  </div> 
					  <div className="col-md-6">
						<label className="form-label" for="email">Email<span className="req-star">*</span></label>
						<input className={validationError.emailError ? 'form-control is-invalid' : 'form-control'} id="email" name="email" placeholder="Enter email address" type="text" onChange={inputHandler} autocomplete="off" />
						<div className="invalid-feedback">{validationError.emailError}</div>
					  </div>
				     <div className="col-md-6">
						<label className="form-label" for="password">Password<span className="req-star">*</span></label>
						<input className={validationError.passwordError ? 'form-control is-invalid' : 'form-control'} id="password" name="password" placeholder="Enter password" type="password" onChange={inputHandler} autocomplete="off" />
						<div className="invalid-feedback">{validationError.passwordError}</div>
					  </div>	
					  
					  				  
					 <div className="col-md-6">
						<label className="form-label" for="phone">Phone<span className="req-star">*</span></label>
						<input className={validationError.phoneError ? 'form-control is-invalid' : 'form-control'} id="phone" name="phone" placeholder="Enter phone number" type="text" onChange={inputHandler} onKeyPress={handleKeyPress} maxlength="10"/>
						<div className="invalid-feedback">{validationError.phoneError}</div>
					  </div>					  
					  <div className="col-md-6">
						<label className="form-label" for="company">Company name<span className="req-star">*</span></label>
						<input className={validationError.companyError ? 'form-control is-invalid' : 'form-control'}  id="company" name="company" placeholder="Enter company name" type="text" onChange={inputHandler} maxLength="30" />
						<div className="invalid-feedback">{validationError.companyError}</div>
					  </div> 					  
					  <div className="col-md-6">
						<label className="form-label" for="industry">Industry<span className="req-star">*</span></label>
						<select className={validationError.industryError ? 'form-control is-invalid' : 'form-control'} aria-label="select example" id="industry" name="industry" onChange={inputHandler}>
                              <option value="">Select Industry</option>
                               {industry.length > 0 ? (
									industry.map((ind) => (
										<option key={ind.id} value={ind.id}>{ind.title}</option>
									))
								) : null}                              					
                            </select>
                            <div className="invalid-feedback">{validationError.industryError}</div>
					  </div>
					   <div className="col-md-6">
						<label className="form-label" for="abn">ABN<span className="req-star">*</span></label>
						<input className={validationError.abnError ? 'form-control is-invalid' : 'form-control'} id="abn" name="abn" placeholder="Enter ABN" type="text" inputMode="numeric" maxLength={14} onChange={inputHandler} onPaste={(e) => {
							e.preventDefault();
							const pasted = (e.clipboardData.getData("text") || "").replace(/\D/g, "").slice(0, 11);
							setForm((old) => ({ ...old, abn: pasted }));
						}} />
						<div className="invalid-feedback">{validationError.abnError}</div>
					  </div> 
					   <div className="col-md-12">
						<label className="form-label" for="address">Address<span className="req-star">*</span></label>
						<input className={validationError.addressError ? 'form-control is-invalid' : 'form-control'}  id="address" name="address" placeholder="Enter address" type="text" onChange={inputHandler} />
						<div className="invalid-feedback">{validationError.addressError}</div>
					  </div> 					  
					  <div className="col-md-6">
						<label className="form-label" for="suburb">Suburb<span className="req-star">*</span></label>
						<input className={validationError.suburbError ? 'form-control is-invalid' : 'form-control'} id="suburb" name="suburb" placeholder="Enter suburb" type="text" onChange={(e) => SearchSuburb(e.target.value)} autocomplete="off" value={suburb} />
						<span className="invalid-feedback">{validationError.suburbError}</span>
						{SuburbsearchResults.length > 0 ? (
							<ul className="suburbList">
								{SuburbsearchResults.map((row) => (
									<li key={row.id} onClick={() => handleSelectSuburb(row)}>
										{row.rowlocation} 
									</li>
								))}
							</ul>
						) : null}
					  </div>
					   <div className="col-md-6">
						<label className="form-label" for="postcode">Postcode<span className="req-star">*</span></label>
						<input className={validationError.postcodeError ? 'form-control is-invalid' : 'form-control'} id="postcode" name="postcode" value={postcode} placeholder="Enter postcode" type="text" readonly disabled />
						<div className="invalid-feedback">{validationError.postcodeError}</div>
					  </div> 
					   <div className="col-md-6">
						<label className="form-label" for="state">State<span className="req-star">*</span></label>
						<select className={validationError.stateError ? 'form-control is-invalid' : 'form-control'} aria-label="select example" id="state" name="state" onChange={inputHandler} value={form.state} readonly disabled>
                              <option value="">Select state</option>
                              <option value="ACT">Australian Capital Territory</option>
							  <option value="NSW">New South Wales</option>
							  <option value="NT">Northern Territory</option>
							  <option value="QLD">Queensland</option>
							  <option value="SA">South Australia</option>
							  <option value="TSA">Tasmania</option>
							  <option value="VIC">Victoria</option>
							  <option value="WA">Western Australia</option>					
                            </select>
						<div className="invalid-feedback">{validationError.stateError}</div>
					  </div> 
					   <div className="col-md-6">
						<label className="form-label" for="minimum_order_total">Minimum order total<span className="req-star">*</span></label>
						<input className={validationError.minimum_order_totalError ? 'form-control is-invalid' : 'form-control'} id="minimum_order_total" name="minimum_order_total" placeholder="Enter minimum order total" type="text" onChange={inputHandler} onKeyPress={handleKeyPress}/>
						<div className="invalid-feedback">{validationError.minimum_order_totalError}</div>
					  </div> 
					  <div className="col-md-6">
						<label className="form-label" for="monthly_spend">Average monthly spend<span className="req-star">*</span></label>
						<select className={validationError.monthly_spendError ? 'form-control is-invalid' : 'form-control'} aria-label="select example" id="monthly_spend" name="monthly_spend" onChange={inputmonthly_spendHandler}>
                              <option value="">Select average monthly spend</option>
                               {monthly_spend.length > 0 ? (
									monthly_spend.map((ms) => (
										<option key={ms.id} value={ms.id}>{ms.title}</option>
									))
								) : null} 					
                            </select>
                            <div className="invalid-feedback">{validationError.monthly_spendError}</div>
					  </div>					 
						  <div className="col-md-6">
							<label className="form-label" for="is_cod">Would you like to be on a COD or a 30 day account?<span className="req-star">*</span></label>
							<select className={validationError.is_codError ? 'form-control is-invalid' : 'form-control'} aria-label="select example" id="is_cod" name="is_cod" onChange={inputHandler} value={form?.is_cod}>
								  <option value="">Select</option>
								  <option value="1">COD</option>
								  <option value="2">30 Day EOM Credit Account</option>				
								</select>
								<div className="invalid-feedback">{validationError.is_codError}</div>
						  </div>
						 
					  <div className="col-md-4">
						<label className="form-label" for="free_shipping">Free shipping<span className="req-star">*</span></label>
						<select className={validationError.free_shippingError ? 'form-control is-invalid' : 'form-control'} aria-label="select example" id="free_shipping" name="free_shipping" onChange={inputHandler}>
							  <option value="">Select</option>
							  <option value="0">No</option>
							  <option value="1">Yes</option>				
							</select>
							<div className="invalid-feedback">{validationError.free_shippingError}</div>
					  </div>
					  <div className="col-md-4">
						<label className="form-label" for="minimum_amout_for_free_shipping">Minimum ammount for free shipping<span className="req-star">*</span></label>
						<input className={validationError.minimum_amout_for_free_shippingError ? 'form-control is-invalid' : 'form-control'} id="minimum_amout_for_free_shipping" name="minimum_amout_for_free_shipping" placeholder="Enter minimum order total" type="text" onChange={inputHandler} onKeyPress={handleKeyPress} />
						<div className="invalid-feedback">{validationError.minimum_amout_for_free_shippingError}</div>
					  </div>
					  <div className="col-md-4">
						<label className="form-label" for="override_global_free_shipping">Override Global Free Shipping</label>
						<select className='form-control' aria-label="select example" id="override_global_free_shipping" name="override_global_free_shipping" onChange={inputHandler} value={form.override_global_free_shipping}>
							  <option value="">Select</option>
							  <option value="0">No</option>
							  <option value="1">Yes</option>				
							</select>
					  </div>
					  
					  
					  <div className="col-md-6">
						<label className="form-label" for="tiered_group">Tiered group<span className="req-star">*</span></label>
						<select className={validationError.tiered_groupError ? 'form-control is-invalid' : 'form-control'} aria-label="select example" id="tiered_group" name="tiered_group" onChange={inputHandler}>
							  <option value="">Select</option>
							  {tiered_group.length > 0 ? (
									tiered_group.map((tg) => (
										<option key={tg.id} value={tg.id}>{tg.title}</option>
									))
								) : null} 			
							</select>
							<div className="invalid-feedback">{validationError.tiered_groupError}</div>
					  </div>					  
					  <div className="col-md-6">
						<label className="form-label" for="owner_id">Owner</label>
						<select className="form-control" aria-label="select example" id="owner_id" name="owner_id" onChange={inputHandler}>
							  <option value="">Select</option>
							  {owners.length > 0 ? (
									owners.map((owner) => (
										<option key={owner.id} value={owner.id}>{owner.first_name} {owner.last_name}</option>
									))
								) : null} 			
							</select>							
					  </div>	
					  
					  <div className="col-md-6">
						<label className="form-label" for="accounts_email_address">Accounts Email Address</label>
						<input className="form-control" id="accounts_email_address" name="accounts_email_address" placeholder="Enter accounts email address" type="text" onChange={inputHandler} autocomplete="off" />						
					  </div>	
					  <div className="col-md-6">				  
						  <div className="form-group mt-5">
							<input className="checklabel" type="checkbox" id="send_emails_to_both_emails" name="send_emails_to_both_emails" value="1" onChange={handleinvoiceCheckboxChange}/>
							<label for="vehicle1">&nbsp; Send invoices to both emails </label>
						</div>
					</div>
					<div className="col-md-12">
						<label className="form-label" for="other_email_addresss">Other Email Addresses</label>
						<input className="form-control" id="other_email_addresss" name="other_email_addresss" placeholder="Enter other email address" type="text" onChange={inputHandler} autocomplete="off" />						
					  </div>
					  
					  				  
					  <div className="col-12 text-end">
						{formErrors.length ? <div className="text-danger mb-2">Please fix the fields marked in red (listed at the top of the form).</div> : null}
						{saveError ? <div className="text-danger mb-2" role="alert">{saveError}</div> : null}
						<button className="btn btn-primary" type="submit" onClick={SubmitForm} disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
					  </div>
					  					  
				  </form>                
                </div>
              </div>
            </div>
          </div>          
        </div>
      </div>    
      <Footer />
      </div>
    </>
  )

}
export default CreateUser;
